import {MaintainAppConfig, MaintainAppName} from '@hconnect/common/hproduce/maintain.types'

import {links as rcfaLinks, LinkTo} from '../../rcfa/routes'

type AppLinks = {
  [K in MaintainAppName]: LinkTo[]
}

const dashboardLink: LinkTo = {
  translationKey: 'Dashboard',
  to: '',
  subItems: undefined,
  activateOnlyIfExact: true
}

const rcfaLink: LinkTo = {
  to: '/rcfa',
  translationKey: 'Root Cause Analysis',
  activateOnlyIfExact: true
}

const pmLinks: LinkTo[] = [
  {
    to: '/pm',
    translationKey: 'Plant Monitoring',
    activateOnlyIfExact: true
  },
  {
    to: '/pm/kms',
    translationKey: 'Kiln Monitoring',
    activateOnlyIfExact: false
  }
]

export const appLinks: AppLinks = {
  Rcfa: [dashboardLink, ...rcfaLinks],
  PM: [dashboardLink, rcfaLink, ...pmLinks],
  default: [dashboardLink, rcfaLink, ...pmLinks],
  Maintain: []
}

const getAppLinks = (rcfaAllowed: boolean, pmAllowed: boolean): AppLinks => {
  const rcfaFiteredLink = rcfaAllowed ? [rcfaLink] : []
  const pmFitleredLinks = pmAllowed ? pmLinks : []

  return {
    Rcfa: [dashboardLink, ...rcfaLinks],
    PM: [dashboardLink, ...rcfaFiteredLink, ...pmFitleredLinks],
    default: [dashboardLink, ...rcfaFiteredLink, ...pmFitleredLinks],
    Maintain: []
  }
}

export const getNavItems = (
  appName: MaintainAppName,
  plantId: string,
  t,
  allowedApps: MaintainAppConfig[]
) => {
  const rcfaAllowed = allowedApps.some((app) => app.urlAlias === 'rcfa')
  const pmAllowed = allowedApps.some((app) => app.urlAlias === 'pm')

  const filteredAppLinks = getAppLinks(rcfaAllowed, pmAllowed)

  return filteredAppLinks[appName].map((link) => ({
    label: t(link.translationKey),
    url: `/plant/${plantId}${link.to}`,
    activateOnlyIfExact: link.activateOnlyIfExact,
    subItems: link.subItems?.map((subItem) => ({
      label: t(subItem.translationKey),
      url: `/plant/${plantId}${subItem.to}`,
      activateOnlyIfExact: subItem.activateOnlyIfExact
    }))
  }))
}
